import DocPage from "../components/DocPage";
import { Link } from "react-router";

function PrivacyPage() {
  return (
    <DocPage
      eyebrow="Privacy Policy"
      title="How we handle your information"
      lede="SimFinance is designed with strong data protection principles and aligns with Ghana’s Data Protection Act, consumer protection requirements, and electronic communication regulations."
    >
      <section>
        <h2 className="text-lg font-semibold tracking-tight text-navy">What this policy covers</h2>
        <p className="mt-2">
          This notice describes information collected through the SimFinance website forms: live demonstration
          requests, specialist callbacks, and newsletter subscriptions. It does not replace the data-processing
          terms that apply when an institution uses SimVerify, SimCollect, or other platform services.
        </p>
      </section>

      <section>
        <h2 className="text-lg font-semibold tracking-tight text-navy">Information we collect</h2>
        <p className="mt-2">
          Depending on the form you use, we may collect your name, company, email address, phone number,
          institution type, and preferred call time. Newsletter signup collects an email address only.
        </p>
      </section>

      <section>
        <h2 className="text-lg font-semibold tracking-tight text-navy">How we use it</h2>
        <p className="mt-2">
          We use this information to respond to your request, schedule a demonstration or callback, discuss
          partnership, and send the updates you asked for. We do not sell your contact details.
        </p>
      </section>

      <section>
        <h2 className="text-lg font-semibold tracking-tight text-navy">Sharing</h2>
        <p className="mt-2">
          We may share information with service providers who help us operate the website (for example email
          or scheduling tools) under appropriate safeguards, or where the law requires us to do so.
        </p>
      </section>

      <section>
        <h2 className="text-lg font-semibold tracking-tight text-navy">Your rights</h2>
        <p className="mt-2">
          Subject to Ghana’s Data Protection Act, you may request access to, correction of, or deletion of
          personal data we hold about you, or object to certain processing. Use the contact form on this
          website to make a request.
        </p>
      </section>

      <section>
        <h2 className="text-lg font-semibold tracking-tight text-navy">Contact</h2>
        <p className="mt-2">
          For privacy questions,{" "}
          <a
            href="/#contact"
            className="font-semibold text-navy underline decoration-gold/80 underline-offset-[5px] hover:decoration-gold"
          >
            request a demonstration
          </a>{" "}
          or ask a specialist to contact you, and include “Privacy” in your message. Related website terms are
          in our{" "}
          <Link
            to="/legal"
            className="font-semibold text-navy underline decoration-gold/80 underline-offset-[5px] hover:decoration-gold"
          >
            Legal
          </Link>{" "}
          page.
        </p>
      </section>
    </DocPage>
  );
}

export default PrivacyPage;
